module.exports = __webpack_public_path__ + "static/media/Startup_Opps_Image.4eef3e8d.jpg";